<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-view-list</v-icon>
      <v-toolbar-title>Reserve Tracking</v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :items="clmItemReserves"
      :search="search"
      :headers="headers"
      v-bind:options.sync="pagination"
      :server-items-length="totalItems"
      hide-default-footer
    >
      <template v-slot:item="row"
        ><tr>
          <td class="text-xs-left">{{ row.item.clmtNo }}</td>
          <td class="text-xs-left">{{ row.item.clmItem }}</td>
          <td>{{ getParamReserve(row.item.clmResCat).label }}</td>
          <td class="text-xs-left">{{ formatDateTime2(row.item.tranDate) }}</td>
          <td class="text-xs-left">{{ row.item.acctMth }}</td>
          <td class="text-xs-left">{{ row.item.acctYr }}</td>
          <td class="text-right">{{ row.item.reserve }}</td>
          <td class="text-right">{{ row.item.reserveLoc }}</td>
          <td class="text-xs-left">{{ formatDateTime2(row.item.entryDate) }}</td>
          <td class="text-xs-left">{{ row.item.userId }}</td>
        </tr></template
      >
    </v-data-table>
    <v-card-actions class="elevation-5">
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="doCancel">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
export default {
  data() {
    return {
      headers: [
        { text: 'Claimant', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'Payment Catalog', align: 'left', value: 'clmResCat' },
        { text: 'Trans Date', align: 'left', value: 'tranDate' },
        { text: 'Acct Month', align: 'left', value: 'acctMth' },
        { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'Reserve Amt', align: 'right', value: 'reserve' },
        { text: 'Reserve Amt (Local)', align: 'right', value: 'reserveLoc' },
        { text: 'Entry Date', align: 'left', value: 'entryDate' },
        { text: 'User ID', align: 'left', value: 'userId' }
      ],
      pagination: {
        sortDesc: [true],
        sortBy: 'tranDate'
      }
    }
  },
  computed: {
    reserveList() {
      return this.$store.state.claims.claimParams.reservesList
    },
    selectedClmItem() {
      return this.$store.state.claims.claimDetail.selectedClmItem || {}
    },
    clmItemReserves() {
      let result = this.selectedClmItem.clmItemReserves
      if (result && result.length > 0) {
        return result
      }
      return []
    },
    totalItems() {
      let result = this.selectedClmItem.clmItemReserves
      return result.length
    }
  },
  methods: {
    getParamReserve(key) {
      for (let paramReserve of this.reserveList) {
        if (paramReserve.value === key) {
          return paramReserve
        }
      }
      return {}
    },
    doCancel() {
      this.$emit('close')
    }
  },
  mixins: [TableConst.default]
}
</script>

<style>
</style>
